import { ProductType, SubscriptionData } from '@riseupil/billing-client';
import { clientWithoutInterceptors } from '../utils/http';

export async function getSubscription(marketId: string): Promise<SubscriptionData> {
  const response = await clientWithoutInterceptors.get(`/api/billing/v1/subscription/${marketId}`);
  return response.data;
}

export async function createCheckoutSession(
  marketId: string,
  productIds: string[],
  successUrl: string,
  cancelUrl: string,
  coupon: string| undefined,
) : Promise<string> {
  const response = await clientWithoutInterceptors.post(
    '/api/billing/v1/create-checkout/',
    { marketId, productIds, successUrl, cancelUrl, type: ProductType.enum.Subscription, coupon },
  );
  return response.data;
}

export async function getCouponDetailsByPromoCode(
  promoCode: string,
) : Promise<string> {
  const response = await clientWithoutInterceptors.get(
    `/api/billing/v1/promo/${promoCode}`,
  );
  return response.data;
}

export async function createManagementPortal(marketId: string, returnUrl: string): Promise<string> {
  const response = await clientWithoutInterceptors.post(
    `/api/billing/v1/create-management-portal/${marketId}`,
    { returnUrl },
  );
  return response.data;
}
